import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import SearchForm from "../components/SearchForm";
import {
  Button,
  CircularProgress,
  Grid,
  Modal,
  Pagination,
  PaginationItem,
  Typography,
} from "@mui/material";
import ModalReset from "../components/Generics/Modal/ModalReset";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import axios from "axios";
import ModalSuccess from "../components/Generics/Modal/ModalSuccess";
import ModalHelper from "../components/Generics/Modal/ModalHelper";

const SigningPending = () => {
  // let access_token = Cookies.get("access_token");
  const access_token = localStorage.getItem("token");
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState(searchParams.get("search") || "");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [responseEp, setResponseEp] = useState(false);
  const [responseDep, setResponseDep] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showRestart, setShowRestart] = useState(false);
  const [showRestartSuccess, setShowRestartSuccess] = useState(false);
  const [isRestartProceedButtonDisabled, setIsRestartProceedButtonDisabled] =
    useState(false);
  const [idPaperworkRestart, setIdPaperworkRestart] = useState("");
  const [currentPagination, setCurrentPagination] = useState(1);
  //const [rateoPagination, setRateoPagination] = useState(5);
  let rateoPagination = 10;

  const navigate = useNavigate();

  const handleSearch = (term) => {
    setSearchTerm(term);
    setCurrentPage(1);
    setResponseEp(false); // Forza il ricaricamento dei dati

    // Aggiorna la query string
    if (term) {
      setSearchParams({ search: term });
    } else {
      setSearchParams({});
    }
  };

  const handleRestart = (input) => () => {
    setIsLoading(true);
    setShowRestart(false);
    const fData = new FormData();
    fData.append("paperwork_id", input);

    setIsRestartProceedButtonDisabled(true);

    const endpoint = process.env.REACT_APP_ENPOINT + "restart-signing";

    axios
      .post(endpoint, fData, {
        headers: {
          Authorization: "Bearer " + access_token,
        },
      })
      .then((res) => {
        if (res.data?.error) {
          alert(res.data.error);
          setIsLoading(false);
        } else {
          setShowRestartSuccess(true);
          // setTimeout(function () {
          //   window.location.reload(false);
          // }, 5000);
          setIsLoading(false);
        }
      })
      .catch((e) => {
        console.error("Failure", e);
      });
  };

  // click update data
  const handleChangeData = (path) => () => {
    navigate(path);
  };

  let endpoint = process.env.REACT_APP_ENPOINT + "is-user-logged";

  let auth = false;

  const isUserLogged = async () => {
    //e.preventDefault();
    const response = await fetch(endpoint, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        Authorization: "Bearer " + access_token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    const result = await response.json();

    //console.log(access_token);

    //console.log(result);
    //const navigate = useNavigate();
    //result === 'auth' ? navigate('/signing-pending') : null;
    if (result === "auth") {
      setIsLoggedIn(true);
    }
    return result;
  };

  useEffect(() => {
    isUserLogged();
  }, []);

  if (isLoggedIn) {
    const getListPending = async () => {
      if (!responseEp) {
        let endpoint = process.env.REACT_APP_ENPOINT + "signing";

        const params = {
          status: "pending",
          page: currentPage
        };
        if (searchTerm) {
          params.search = searchTerm;
        }

        const response = await axios({
          method: "get",
          url: endpoint,
          params: params,
          headers: {
            Authorization: `Bearer ${access_token}`,
            Accept: "application/json",
          },
        });
        console.log("API Response:", response.data);
        const result = Array.isArray(response.data) ? response.data : (response.data.data || []);
        setData(result);
        setTotalPages(response.data.last_page || 1);
        setResponseEp(true);
      }
    };
    getListPending();
  }

  // modal

  const handleGoBackRestart = () => {
    setShowRestart(false);
  };

  const handleGoBackRestartSuccess = () => {
    setShowRestartSuccess(false);
    window.location.reload(false);
  };

  const handleShowModalRestart = (id_paperwork) => () => {
    setShowRestart(true);
    setIdPaperworkRestart(id_paperwork);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
    setResponseEp(false); // Forza il ricaricamento con la nuova pagina
  };

  // overlay e modal alert visualizzazione mobile ruota display

  const [showRotateModal, setShowRotateModal] = useState(() => {
    const hasSeenModal = localStorage.getItem("rotateModalDismissed");
    return window.innerWidth < 600 && !hasSeenModal;
  });

  const handleCloseRotateModal = () => {
    localStorage.setItem("rotateModalDismissed", "true");
    setShowRotateModal(false);
  };

  useEffect(() => {
    const handleResize = () => {
      const hasSeenModal = localStorage.getItem("rotateModalDismissed");
      if (window.innerWidth < 600 && !hasSeenModal) {
        setShowRotateModal(true);
      } else {
        setShowRotateModal(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div style={{ marginTop: "120px" }}>
        <Grid container style={{ display: "flex", justifyContent: "center", marginTop: "230px" }}>
          <Grid item xs={10} md={10}>
            <Typography
              className="color-blue-dark"
              style={{
                fontSize: "22px",
                fontWeight: 600,
                marginBottom: "30px",
              }}
            >
              Signing in corso
            </Typography>

            <div>
              {!responseEp ? null : (
                <>
                  <SearchForm onSearch={handleSearch} initialValue={searchTerm} />
                  {searchTerm && data.length === 0 ? (
                    <Typography
                      className={"color-blue-dark"}
                      sx={{
                        fontSize: { xs: "16px", md: "18px" },
                        fontWeight: 600,
                        marginTop: "30px",
                        marginBottom: "30px",
                      }}
                    >
                      Nessun risultato trovato.
                    </Typography>
                  ) : null}
                  <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
                    <Table sx={{ minWidth: 300 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell
                            className="color-blue-dark"
                            sx={{
                              padding: "8px",
                              whiteSpace: { xs: "nowrap", sm: "normal" },
                            }}
                          >
                            <Typography className="title-column-table text-bold">
                              ID
                            </Typography>
                          </TableCell>
                          <TableCell
                            className="color-blue-dark"
                            sx={{
                              padding: "8px",
                              whiteSpace: { xs: "nowrap", sm: "normal" },
                            }}
                          >
                            <Typography className="title-column-table text-bold">
                              Nome operazione
                            </Typography>
                          </TableCell>
                          <TableCell
                            className="color-blue-dark"
                            sx={{
                              padding: "8px",
                              whiteSpace: { xs: "nowrap", sm: "normal" },
                            }}
                          >
                            <Typography className="title-column-table text-bold">
                              Data creazione
                            </Typography>
                          </TableCell>
                          <TableCell
                            className="color-blue-dark"
                            sx={{
                              padding: "8px",
                              whiteSpace: { xs: "nowrap", sm: "normal" },
                            }}
                          >
                            <Typography className="title-column-table text-bold">
                              Team
                            </Typography>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data.map((item, index) => {
                          const date = new Date(item.updated_at);
                          const timestamp = date.getTime();
                          const date2 = new Date(timestamp);
                          const dateLocale = date2.toLocaleString("it-IT");

                          return (
                            <TableRow key={index}>
                              <TableCell
                                sx={{
                                  padding: "8px",
                                  whiteSpace: { xs: "nowrap", sm: "normal" },
                                }}
                                className="color-blue-dark"
                              >
                                <Typography className="text-table">
                                  {item.id}
                                </Typography>
                              </TableCell>
                              <TableCell
                                sx={{
                                  padding: "8px",
                                  whiteSpace: { xs: "nowrap", sm: "normal" },
                                }}
                              >
                                <a
                                  className="text-table color-purple"
                                  href={"/paperwork/" + item.id}
                                >
                                  {item.paperwork_name}
                                </a>
                              </TableCell>
                              <TableCell
                                sx={{
                                  padding: "8px",
                                  whiteSpace: { xs: "nowrap", sm: "normal" },
                                }}
                                className="color-blue-dark"
                              >
                                <Typography className="text-table">
                                  {dateLocale}
                                </Typography>
                              </TableCell>
                              <TableCell
                                sx={{
                                  padding: "8px",
                                  whiteSpace: { xs: "nowrap", sm: "normal" },
                                }}
                                className="color-blue-dark"
                              >
                                <Typography className="text-table">
                                  {item.department_name}
                                </Typography>
                              </TableCell>
                              {/* <TableCell
                              sx={{
                                padding: "8px",
                                width: "150px",
                                // textAlign: "center",
                              }}
                              className="color-blue-dark"
                            >
                              <Typography
                                className="text-table"
                                style={{ fontSize: "bold" }}
                              >
                                on going
                              </Typography>
                            </TableCell> */}

                              {/* <TableCell
                              sx={{
                                fontSize: "0.9rem",
                                padding: "8px",
                                width: "150px",
                              }}
                            >
                              <Button
                                variant="outlined"
                                className="button-bg-empty-small"
                                onClick={handleShowModalRestart(item.id)}
                                sx={{
                                  marginBottom: 0,
                                }}
                              >
                                <Typography
                                  className="color-blue-dark"
                                  style={{
                                    textTransform: "initial",
                                    fontSize: "14px",
                                    fontWeight: 500,
                                  }}
                                >
                                  Restart
                                </Typography>
                              </Button>
                            </TableCell>
                            <TableCell
                              sx={{
                                padding: "8px",
                                width: "150px",
                              }}
                            >
                              {item.id >= 203 ? (
                                <Button
                                  className="button-bg-purple-small"
                                  onClick={handleChangeData(
                                    "/paperwork/" + item.id
                                  )}
                                  sx={{
                                    marginBottom: 0,
                                    border: "none",
                                  }}
                                >
                                  <Typography
                                    className="color-light"
                                    style={{
                                      textTransform: "initial",
                                      fontSize: "14px",
                                      fontWeight: 500,
                                    }}
                                  >
                                    Update data
                                  </Typography>
                                </Button>
                              ) : (
                                <Button
                                  disabled
                                  variant="outlined"
                                  className="button-bg-purple-small"
                                  onClick={handleChangeData(
                                    "/paperwork/" + item.id
                                  )}
                                  sx={{
                                    marginBottom: 0,
                                    opacity: 0.7,
                                  }}
                                >
                                  <Typography
                                    className="color-light"
                                    style={{
                                      textTransform: "initial",
                                      fontSize: "14px",
                                      fontWeight: 500,
                                    }}
                                  >
                                    Update data
                                  </Typography>
                                </Button>
                              )}
                            </TableCell> */}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              )}
            </div>
          </Grid>
        </Grid>
        {!responseEp ? null : (
          <Grid
            container
            justifyContent="center"
            style={{ marginTop: "30px", marginBottom: "30px" }}
          >
            <Pagination
              count={totalPages}
              page={currentPage}
              onChange={handlePageChange}
              renderItem={(item) => (
                <PaginationItem
                  {...item}
                  sx={{
                    color: item.page === currentPage ? "#fff" : "#1b2838",
                    backgroundColor:
                      item.page === currentPage
                        ? "#1b2838 !important"
                        : "transparent",
                    "&:hover": {
                      backgroundColor:
                        item.page === currentPage
                          ? "primary.dark"
                          : "transparent",
                    },
                  }}
                />
              )}
            />
          </Grid>
        )}
      </div>

      <Modal open={showRestart} onClose={handleGoBackRestart}>
        <ModalReset
          title="Restart"
          descriptionOne={
            <>
              <strong>By reinitializing the signature process:</strong>
              <br />
              <ul className={"list-circle"}>
                <li>previous operation will be deleted</li>
                <li>further costs will be charged on Lexia</li>
                <li>
                  signers who had already signed the documents will be asked to
                  sign again
                </li>
              </ul>
              Deleting ID:: {idPaperworkRestart}
              <br />
            </>
          }
          descriptionTwo=""
          copyButton="Proceed"
          onClose={handleGoBackRestart}
          confirm={handleRestart(idPaperworkRestart)}
        />
      </Modal>

      <Modal open={showRestartSuccess} onClose={handleGoBackRestartSuccess}>
        <ModalSuccess
          title="Title"
          descriptionOne="copy"
          descriptionTwo="copy"
          copyButton="Close"
          confirm={handleGoBackRestartSuccess}
          onClose={handleGoBackRestartSuccess}
        />
      </Modal>

      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <CircularProgress style={{ color: "#1b2838" }} />
        </div>
      )}

      {showRotateModal && (
        <Modal
          open={showRotateModal}
          onClose={handleCloseRotateModal}
        >
          <div>
            <ModalHelper
              onClose={handleCloseRotateModal}
              modalObjectInfo={{
                infoTitle: "Visualizzazione",
                description:
                  "A seconda del tuo smartphone e delle tue preferenze, puoi ruotare lo schermo per una visione orizzontale.",
                descriptionBis: "",
              }}
            />
          </div>
        </Modal>
      )}
    </>
  );
};
export default SigningPending;
